var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCredit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "credit-card-svgrepo-com",
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.615,
    height: 27.036,
    viewBox: "0 0 37.615 27.036",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_741",
    "data-name": "Path 741",
    fill: "#E4E7E7",
    d: "M2.351,41.03H35.264a2.351,2.351,0,0,1,2.351,2.351V65.714a2.353,2.353,0,0,1-2.351,2.352H2.351A2.352,2.352,0,0,1,0,65.714V43.381A2.35,2.35,0,0,1,2.351,41.03Z",
    transform: "translate(0 -41.03)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_742",
    "data-name": "Path 742",
    fill: "#cdcfcf",
    d: "M39.108,177.795v2.351H57.915v-2.351Zm0,5.877H50.862v-2.351H39.108Zm-4.7-5.877H29.7a2.352,2.352,0,0,0-2.351,2.351v1.176a2.352,2.352,0,0,0,2.351,2.351h4.7a2.352,2.352,0,0,0,2.351-2.351v-1.176A2.352,2.352,0,0,0,34.406,177.795Z",
    transform: "translate(-23.827 -160.163)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_743",
    "data-name": "Path 743",
    fill: "#f1f1f1",
    d: "M27.353,123.089H57.915v3.526H27.353Z",
    transform: "translate(-23.827 -112.51)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_744",
    "data-name": "Path 744",
    fill: "#324d5b",
    d: "M0,68.383H37.615v3.526H0Z",
    transform: "translate(0 -64.857)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCredit);
export default __webpack_public_path__ + "static/media/credit.42e6c1c6837c47b76f93c504ae4a62fa.svg";
export { ForwardRef as ReactComponent };